import { render, staticRenderFns } from "./proDashboard.vue?vue&type=template&id=77b79d4c&scoped=true"
import script from "./proDashboard.vue?vue&type=script&lang=js"
export * from "./proDashboard.vue?vue&type=script&lang=js"
import style0 from "./proDashboard.vue?vue&type=style&index=0&id=77b79d4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b79d4c",
  null
  
)

export default component.exports